import { BigNumber } from '../common';
import { Type } from 'class-transformer';
import { IsBoolean, IsInt, IsOptional, IsPositive } from 'class-validator';
import { IsAddress, IsBigNumberish } from './validators';

export class GetAdvanceRoutesLiFiDto {
  @IsAddress()
  fromTokenAddress: string;

  @IsAddress()
  toTokenAddress: string;

  @IsPositive()
  @IsInt()
  @Type(() => Number)
  fromChainId: number;

  @IsPositive()
  @IsInt()
  @Type(() => Number)
  toChainId: number;

  @IsBigNumberish()
  fromAmount: BigNumber;

  @IsAddress()
  fromAddress: string;

  @IsOptional()
  @IsAddress()
  toAddress?: string;

  @IsOptional()
  @IsBoolean()
  allowSwitchChain?: boolean;

  @IsOptional()
  @IsBoolean()
  showZeroUsd?: boolean;
}
